module.exports = __webpack_public_path__ + "media/pricing/ArtBooks-04522f17.png";